import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import PdfViewModal from 'components/shared/modals/PdfViewModal';

/**
 * Celda "Factura" de las tablas de pagos: en vez de abrir el PDF en otra pestaña, lo muestra
 * EMBEBIDO en un modal (con acciones de abrir-en-pestaña y descargar). Reusa PdfViewModal.
 */
function InvoiceCell({ url = null, label }) {
  const [open, setOpen] = useState(false);
  if (!url) return null;

  return (
    <>
      <Button
        variant="text"
        color="secondary"
        onClick={() => setOpen(true)}
        sx={{ p: 0, minWidth: 0, fontWeight: 700, textTransform: 'none', '&:hover': { backgroundColor: 'transparent', textDecoration: 'underline' } }}
      >
        {label}
      </Button>
      <PdfViewModal open={open} src={url} title={label} filename={label} onClose={() => setOpen(false)} />
    </>
  );
}

InvoiceCell.propTypes = {
  url: PropTypes.string,
  label: PropTypes.string.isRequired
};

export default InvoiceCell;
